import { Flex, Text } from '@mantine/core';
import { StatusDotIcon } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusDotIcon/StatusDotIcon';
import { mapStatusToColor } from '@dealstack/frontend/app/pages/Project/MIP/Messages/components/StatusWithIcon/StatusWithIcon.utils';
import { EmailSentEventStatusResponse } from '@dealstack/shared/lib/backendClient';

interface Props {
	status: EmailSentEventStatusResponse;
	textSize?: number;
	fontWeight?: number;
}

export const StatusWithIcon = ({ status, textSize = 12, fontWeight = 400 }: Props) => {
	const color = mapStatusToColor(status);

	return (
		<Flex align="center" gap="0.5rem">
			<StatusDotIcon color={color} />
			<Text tt="capitalize" fz={textSize} fw={fontWeight}>
				{status}
			</Text>
		</Flex>
	);
};
